import { useAuth } from "@/context/AuthContext";
import { Navigate, useLocation } from "react-router-dom";
import { PAGES, canAccess, navFor } from "@/lib/access";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const location = useLocation();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-slate-950">
        <div className="text-slate-400">Yükleniyor...</div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" state={{ from: location }} replace />;
  const page = PAGES.find((p) => p.to === location.pathname);
  if (page && !canAccess(user, page.to)) {
    const first = navFor(user)[0];
    return first ? <Navigate to={first.to} replace /> : <div className="min-h-screen flex items-center justify-center bg-slate-950 text-slate-400">Erişim yetkiniz olan sayfa yok.</div>;
  }
  return children;
}
